import PublicLayout from '../components/layouts/PublicLayout';
import { Container } from 'reactstrap';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router'

function BrandBuilder({meta}) {
    const [loading, setLoading] = useState(false); 
    const router = useRouter();

	return (
        <>
            <Head>
                <meta name="keywords" content={meta ? meta.keywords : ''} />
                <title>{meta ? meta.title : ''}</title>
                <meta name="description" content={meta ? meta.description : ''} />
                <link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
            </Head>
			<div className="banner_breadcrumb_section" id="brand_builder">
				<div id="spinner" className="spinner_req_review" style={{"display": loading ? "block" : "none"}}>
						<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
				</div>
                <Container fluid="xl">
                <h1 className="main-heading-lg">Brand Builders</h1>
                </Container>
            </div>
            <Container fluid="xl">
                <div className="review-guidelines-page text-center padding-set" >
                <p className="description-text">If you need help building your brand here on Toprow, you will find our brand building tools useful for helping you grow your business. Stand out from the competition by creating a unique profile on Toprow and showcasing your skills. </p>
                <p className="description-text">Need some support along the way?  </p>
                <p className="description-text">Watch this video and utilize our brand building tools.  </p>
                <p className="description-text">Make an impression on your ideal business to get the work process started.</p>
                </div>
            </Container>
        </>
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/brand-builder', { headers: {
            "Accept": "application/json" }
        });

        return { props: { meta: response.data.data,  } }

    } catch (err) {
        const meta = false;

        return { props: { meta } };
    }
}

BrandBuilder.Layout = PublicLayout;

export default BrandBuilder
